import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { ArrowRight } from "lucide-react";

export default function SchoolDetail() {
  const { slug } = useParams();
  const { t, field } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/schools/${slug}`).then((r) => setData(r.data)).catch(() => setData(null)); }, [slug]);
  if (!data) return <Section className="py-24"><p className="text-ink/50">{t("loading")}</p></Section>;
  const { school, programmes } = data;
  return (
    <div>
      <div className="bg-ink text-paper">
        <Section className="py-20 md:py-28">
          <Eyebrow>{school.code}</Eyebrow>
          <h1 className="font-serif text-4xl md:text-6xl tracking-tight max-w-4xl">{field(school, "name")}</h1>
          <p className="mt-5 max-w-2xl text-paper/70 text-lg leading-relaxed">{field(school, "summary")}</p>
        </Section>
      </div>
      <Section className="py-16 md:py-24">
        <Eyebrow>{t("sd_programmes")}</Eyebrow>
        <div className="grid gap-px bg-border border border-border md:grid-cols-2 mt-6">
          {programmes.map((p) => (
            <Link key={p.slug} to={`/programmes/${p.slug}`} data-testid={`school-prog-${p.slug}`} className="group bg-paper p-7 hover:bg-secondary transition-colors">
              <div className="font-mono text-xs text-heraldic uppercase">{p.level}</div>
              <div className="mt-2 font-serif text-xl text-ink leading-snug">{field(p, "name")}</div>
              <div className="mt-2 text-sm text-ink/55">{field(p, "purpose")}</div>
              <ArrowRight className="mt-4 h-4 w-4 text-ink/30 group-hover:translate-x-1 group-hover:text-heraldic transition-all" />
            </Link>
          ))}
          {programmes.length === 0 && <div className="bg-paper p-7 text-ink/50">{t("sd_empty")}</div>}
        </div>
      </Section>
    </div>
  );
}
